<div class="p-fluid grid formgrid">
  <div class="field col-12 md:col-3">
    <label for="r018_enrollment">Matrícula</label>
    <input id="r018_enrollment" type="text" pInputText [(ngModel)]="filters.enrollment"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r018_name">Nome</label>
    <input id="r018_name" type="text" pInputText [(ngModel)]="filters.name"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r018_email">E-mail</label>
    <input id="r018_email" type="text" pInputText [(ngModel)]="filters.email"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r018_prefix">Prefixo</label>
    <input id="r018_prefix" type="number" pInputText [(ngModel)]="filters.prefix"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r018_dependency">Dependência</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r018_dependency" [options]="comboOptions.dependency" [(ngModel)]="filters.dependency"
                placeholder="Todos" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                [showClear]="true" *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r018_state">UF</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r018_state" [options]="comboOptions.state" [(ngModel)]="filters.state" placeholder="Todos"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r018_role">Perfil</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r018_role" [options]="comboOptions.role" [(ngModel)]="filters.role" placeholder="Todos"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r018_accessLevel">Nível de acesso</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r018_accessLevel" [options]="comboOptions.accessLevel" [(ngModel)]="filters.accessLevel"
                placeholder="Todos" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                [showClear]="true" *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r018_status">Situação</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r018_status" [options]="comboOptions.status" [(ngModel)]="filters.status" placeholder="Todos"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
</div>
